import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import showLiveSupport from '@xanadu/ui-shared/utils/showLiveSupport';
// eslint-disable-next-line import/extensions
import CloseBtn from '../widgets/CloseBtn';
import styles from './RateLimits.module.scss';

const title = (isLoggedIn, requestLogin) => {
  if (!isLoggedIn) {
    return (<Fragment>
      You have exceeded the usage limits for anonymous users.
      Please
      <a className={styles.link} onClick={requestLogin} role="button"> login </a>
      to raise this limit.
    </Fragment>);
  }

  return (<Fragment>
    You have exceeded usage limits for your account.
    If you believe this to be an error or you wish to increase your limit, please contact
    <a className={styles.link} onClick={showLiveSupport} role="button"> customer service</a>
    .
  </Fragment>);
};

export default class RateLimits extends Component {
  static get propTypes() {
    return {
      isLoggedIn: PropTypes.bool.isRequired,
      loginRequest: PropTypes.func.isRequired,
      message: PropTypes.string
    };
  }

  static get defaultProps() {
    return {
      message: ''
    };
  }

  constructor() {
    super();

    this.state = {
      dismissedMessage: ''
    };

    this.handleDismiss = this.handleDismiss.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // Dismiss warning if the user has just logged in
    if (nextProps.isLoggedIn && !this.props.isLoggedIn) {
      this.handleDismiss();
    }
  }

  handleDismiss() {
    this.setState({ dismissedMessage: this.props.message });
  }

  render() {
    const {
      isLoggedIn,
      message,
      loginRequest
    } = this.props;

    if (!message || this.state.dismissedMessage === message) {
      return null;
    }

    return (<div className={styles.rateLimits}>
      <p className={styles.title}>
        {title(isLoggedIn, loginRequest)}
      </p>
      <p className={styles.message}>{message}</p>
      <CloseBtn
        onClick={this.handleDismiss}
        className={styles.icon}
      />
    </div>);
  }
}
